import { SearchFormData } from '@/features/approving_invoice_reports/components/Search/hooks/useSearchForm';
import { PropsControl } from '@/features/approving_invoice_reports/components/Search/type';
import {
  FormInput,
  FormInputProps,
} from '@moneyforward/ap-frontend-components';
import { useMemo } from 'react';

type Props = PropsControl & FormInputProps<SearchFormData>;

export const FromInputSearch = ({ control, name, ...rest }: Props) => {
  const inputProps = useMemo(() => ({ ...rest.inputProps }), [rest.inputProps]);
  return (
    <FormInput<SearchFormData>
      name={name}
      control={control}
      inputProps={inputProps}
      {...rest}
    />
  );
};
